export const types = {
    SET_GET_BALANCE_CORRECTION: '[BALANCE CORRECTION] SET GET BALANCE CORRECTION',
    SET_GET_BALANCE_CORRECTION_BY_ID: '[BALANCE CORRECTION] SET GET BALANCE CORRECTION BY ID'
}